import { render } from "./FAQ.vue?vue&type=template&id=751686fa&scoped=true&ts=true"
import script from "./FAQ.vue?vue&type=script&lang=ts"
export * from "./FAQ.vue?vue&type=script&lang=ts"

import "./FAQ.vue?vue&type=style&index=0&id=751686fa&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751686fa"]])

export default __exports__